/* Action tier labels. Enum key maps to the display string. */

export const ActionEnum = {
  ACT: "Act",
  REVIEW: "Review",
  LOG: "Log",
};

export default ActionEnum;
